import { Accordion, AccordionDetails, AccordionSummary, Grid, Pagination, SxProps, Theme, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CorrectedRow, CouponShare } from "../models/couponshares";
import { DetailedRound } from "../models/round";
import { useState } from "react";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { correctRows } from "../common/rowUtil";


function BestRows({ round, couponShare }: { round: DetailedRound, couponShare: CouponShare }) {

    const [pageActive, setPageActive] = useState(0);

    const { t } = useTranslation();

    const styleComponent: SxProps<Theme> = {
        background: "var(--background_3)"
    };

    const styleColumn: SxProps<Theme> = {
        width: "20px",
        margin: "3px"
    };

    const styleTextColumn: SxProps<Theme> = {
        width: "100%",
        textAlign: "center",
        fontSize: "12px",
        color: "var(--text-black-dark-background)"
    };

    let paginationStyle: SxProps<Theme> = {
        marginTop: "20px",
        "& .MuiPaginationItem-root": {
            color: "var(--pagination-text)",
            backgroundColor: "var(--pagination-background)"
        }
        ,
        "& button[aria-current=true]": {
            color: "var(--pagination-selected-text)",
            backgroundColor: "var(--pagination-selected-background)"
        },
    }

    let myRows: any[] = [];
    let correctedRows: CorrectedRow[] = [];

    if (round === undefined || couponShare === undefined)
        return <></>;

    const bets = couponShare?.coupon?.coupon?.bets;

    if (bets?.length) {

        bets.forEach(bet => {
            myRows = myRows.concat(bet.rows);
        });

        correctedRows = correctRows(myRows, round, false);
    }

    const getStyleForSign = (round: DetailedRound, sign: string, gameIndex: number): SxProps<Theme> => {

        let isCorrect = round.preliminaryCorrectRow && round.preliminaryCorrectRow[gameIndex] === sign;
        let isFinished = round.fixtures[gameIndex].status === 'FINISHED';

        if (round.preliminaryCorrectRow === null && sign === 'X') {
            isCorrect = true;
        }

        let style = { ...styleTextColumn, fontWeight: isFinished ? "bold" : "" };

        let correctStyle = { ...style, backgroundColor: 'var(--sign-correct-border)' };

        if (isCorrect) {
            return correctStyle;
        }

        return style;
    };

    return (

        <Accordion sx={styleComponent}>
            <AccordionSummary
                expandIcon={<ArrowDropDownIcon sx={{ color: "var(--text-black-dark-background)" }} />}
                aria-controls="panel1-content"
                id="panel1-header">
                <Typography sx={{ color: "var(--text-black-dark-background)" }}>{t('show_rows')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container justifyContent="center" alignItems="center">
                    {myRows.length > 0 &&
                        (
                            <Grid container direction="row" justifyContent="flex-start">
                                <Grid sx={{ ...styleColumn, width: "60px" }} key={`fixtures`}>

                                    {round.fixtures.map((fixture, k) => {
                                        return (
                                            <Typography key={'number' + k} sx={{ ...styleTextColumn, fontWeight: "bold" }}>{k + 1}.</Typography>
                                        );
                                    })}
                                    <Typography sx={{ ...styleTextColumn, fontWeight: "bold", marginTop: "10px" }}>{t('correct_rows')}</Typography>
                                </Grid>
                                {correctedRows.slice(pageActive * 10, pageActive * 10 + 10).map((row, i) => {
                                    return (
                                        <Grid sx={styleColumn} key={`${i} coupon`}>

                                            {row.row.signs.map((sign, j) => {
                                                return (
                                                    <Typography key={'rownr_' + j} sx={getStyleForSign(round, sign, j)}>{sign.replace('ONE', '1').replace('TWO', '2')}</Typography>
                                                );
                                            })}
                                            <Typography sx={{ ...styleTextColumn, fontWeight: "bold", marginTop: "10px" }}>{row.numCorrect}</Typography>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        )

                    }
                    <Grid container justifyContent="center">
                        <Pagination siblingCount={0} sx={paginationStyle} count={Math.floor(myRows.length / 10) + 1} onChange={(e, page) => setPageActive(page - 1)} />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default BestRows;